<template>
  <div class="gerenciamento-acesso">
    <g-card class="card-gerenciamento-acesso"  :expansivel="true" :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Acessos </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="limparFiltro"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            @click="buscar()"
            gap="10px"
            :sombreado="false"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="gerenciamento-acessos-conteudo espacamento-filtros">            
          <div class="filtro-nome-grupo">
            <div class="titulo-conteudo-filtros"> Grupo </div>
            <PDropDown class="grupo-input input-label"
                       :options="grupoArray"
                       placeholder="Selecione o grupo" 
                       optionLabel="nomeGrupo" 
                       optionValue="id"
                       :disabled="acessoViewModel.UsuarioId != undefined || this.desativaGrupo"
                       v-model="acessoViewModel.GrupoId"/>
          </div>
          
          <div class="filtro-nome-usuario">
            <div class="titulo-conteudo-filtros"> Usuário </div>
          <PDropDown class="usuario-input input-label"
                     :options="UsuarioArray"
                     optionLabel="nomeUsuario"
                     optionValue="id"
                     placeholder="Selecione o usuário"
                     @filter="getUsuario($event.value)"
                     :filter="true"
                     :disabled="acessoViewModel.GrupoId != undefined || this.desativaUsuario"
                     v-model="acessoViewModel.UsuarioId"/>
          </div>
        </div>
      </g-form>

      <div class="buscar-button-filtro">
        <g-button
        class="buscar-button"
        largura="300px"
        icone="icone_lupa.svg"
        negritoTexto
        tamanhoIcone="15px"
        tamanhoTexto="14px"
        altura="35px"
        gap="10px"
        :sombreado="false"
        >
          BUSCAR
        </g-button>
      </div>
    </g-card>
    
    <g-card v-if="!checkValidacao" paddingDefault="1em 0 3em" :temCabecalho="false">
      <img class="icone-global-imagemfundo" src="@/assets/imgs/Ilustracao_erro.svg" />
      <div class="texto-padrao-imagemfundo">
        Verifique os filtros e clique em buscar para exibir os resultados
      </div>
    </g-card>

    <g-card v-else-if="checkValidacao" paddingDefault="0em 0 3em" :temCabecalho="false">

    <div class="titulo-checkbox"> Gerenciamento de Acessos </div>
    
    <gClaims @verificaClaimArray="SetClaims" ref="gClaims" :ClaimArray="ClaimArray" v-model="arrayAcessos" />

    <div class="button-gravar">
      <g-button
            largura="150px"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="14px"
            altura="35px"
            gap="10px"
            @click="GravarAcesso"
            :sombreado="false"
            >
              GRAVAR
            </g-button>
    </div>
    </g-card>
  </div>
</template>

<script>
import GerenciamentoAcessos from "./GerenciamentoAcessos.js";
export default GerenciamentoAcessos;
</script>

<style scoped>
.button-gravar {
  margin-top: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.titulo-checkbox{
  width: 100%;
  color: #3e3e3e;
  text-align: left;
  font-size: 17px;
  font-family: "MontSerrat";
  font-weight: bold;
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
}

.grid-checkbox{
  display: grid;
  grid-template-columns: repeat(5, auto);
  grid-template-rows: repeat(10, auto);
  row-gap: 10px;
  justify-content: start;
  justify-items: start;
  padding-left: 20px;
}

.gerenciamento-usuario {
  grid-area: 1 / 2 / 2 / 1
}

.gerenciamento-cidades {
  grid-area: 2 / 2 / 2 / 1
}

.gerenciamento-grupos {
  grid-area: 3 / 2 / 3 / 1
}

.gerenciamento-acessos {
  grid-area: 4 / 2 / 5 / 1
}

.gerenciamento-transportadoras {
  grid-area: 5 / 2 / 6 / 1
}

.gerenciamento-comissoes {
  grid-area: 6 / 2 / 7 / 1
}

.gerenciamento-log {
  grid-area: 7 / 2 / 8 / 1
}

.gerenciamento-parametros {
  grid-area: 8 / 2 / 9 / 1
}

.gerenciamento-liberacao-representante {
  grid-area: 9 / 2 / 10 / 1
}

.gerenciamento-usuarios-logado {
  grid-area: 10 / 2 / 11 / 1
}

.gerenciamento-condicoes-pagamento {
  grid-area: 11 / 2 / 12 / 1
}

.label-checkbox {
  color: #838383;
  text-align: left;
  font-family: Montserrat;
  margin-left: 6px;
}

.consultar-dados {
  display: flex;
}

@media (min-width:310px) {
    
}

@media (min-width:368px) {

}

@media (min-width:500px) {
.gerenciamento-acessos-conteudo {
  display: grid;
  grid-template-columns: repeat(2, minmax(4em, 22em));
  grid-template-rows: auto;
  grid-column-gap: 20px;
}
.filtro-nome-grupo { grid-area: 1 / 1 / 2 / 2; }
.filtro-nome-usuario { grid-area: 1 / 2 / 2 / 3; }
}

@media (min-width:801px) {
.gerenciamento-acessos-conteudo {
  grid-template-columns: repeat(2, minmax(4em, 22em)) auto;
}
}

@media (min-width:1025px) { 

}

@media (min-width:1281px) { 
    
}

</style>
